import { FC } from 'react';
import classNames from 'classnames';

import * as icons from '@gn-audio/icons';
import { Button, JabraIcon } from '@gn-audio/jss-components';

import HtmlRender from '../HtmlRender';

import styles from './IconTitle.module.scss';

export interface IconTileProps {
  iconName?: keyof typeof icons;
  title: string;
  subtitle?: string;
  htmlContent?: string;
  className?: string;
  link: Pick<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'title' | 'href'> & {
    text: string;
  };
}

const IconTile: FC<IconTileProps> = ({
  iconName = 'icon_3d_cube',
  title,
  subtitle,
  htmlContent = '',
  link,
  className,
}) => (
  <article className={classNames('rounded-md bg-white py-8 lg:p-5', styles.iconTile, className)}>
    <div
      className={classNames(
        'mx-auto flex rounded-full lg:absolute lg:size-[100px] lg:bg-white',
        styles.icon
      )}
    >
      {/* todo: a18y on that? */}
      <JabraIcon
        className="m-auto size-[40px] text-gray-700"
        Icon={icons?.[iconName] || icons.icon_3d_cube}
      />
    </div>
    <div className="flex h-full flex-col text-gray-700">
      <div className="flex flex-col">
        <h2 className="mb-3 mt-5 text-center font-semibold text-black lg:mt-12 lg:text-2xl">
          {title}
        </h2>
        <p className="mb-4 text-center">{subtitle}</p>
        <HtmlRender
          element="div"
          className={classNames('mb-4 ml-4 font-light', styles.htmlBody)}
          html={htmlContent}
        ></HtmlRender>
      </div>
      {link?.href && link.text ? (
        <div className={classNames('mt-auto flex justify-center', styles.buttonWrapper)}>
          <Button
            asLink
            variant="link"
            size="m"
            href={link?.href}
            target={link.target}
            className="mt-auto rounded-full text-base font-semibold transition-colors hover:no-underline"
            title={link?.title}
          >
            <span className="flex items-center text-wrap text-center">
              {link?.text}
              <JabraIcon className="ml-2 size-2" Icon={icons.icon_chevron_right} />
            </span>
          </Button>
        </div>
      ) : null}
    </div>
  </article>
);

export default IconTile;
